import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface SearchLink {
  label: string;
  url: string;
}

@Component({
  selector: 'app-reference-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div class="ref-card">
      <div class="ref-card__header">
        <mat-icon class="ref-card__icon">search</mat-icon>
        <span class="ref-card__title" i18n="@@details.referenceCard.title">関連情報をGoogleで検索</span>
      </div>
      <div class="ref-card__pills">
        @for (link of searchLinks(); track link.label) {
          <a class="ref-pill" (click)="onLinkClick($event, link.url)">
            {{ link.label }}
            <mat-icon class="ref-pill__external">open_in_new</mat-icon>
          </a>
        }
      </div>
    </div>
  `,
  styles: [`
    .ref-card {
      padding: var(--space-md) var(--space-lg);
      border-radius: var(--radius-lg);
      background: var(--gokuri-surface);
      border: 1px solid var(--gokuri-border-light, #e8e8e8);
    }
    .ref-card__header {
      display: flex;
      align-items: center;
      gap: var(--space-sm);
      margin-bottom: var(--space-sm);
    }
    .ref-card__icon {
      font-size: 18px;
      width: 18px;
      height: 18px;
      color: var(--gokuri-text-secondary);
    }
    .ref-card__title {
      font-size: var(--font-size-body-md);
      font-weight: 600;
      color: var(--gokuri-text-primary);
    }
    .ref-card__pills {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-sm);
    }
    .ref-pill {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: var(--font-size-body-sm);
      color: #ffffff;
      background: var(--gokuri-primary);
      padding: var(--space-xs) var(--space-sm);
      border-radius: var(--radius-full);
      text-decoration: none;
      cursor: pointer;
      transition: background var(--transition-fast, 150ms ease);
    }
    .ref-pill:hover {
      background: var(--gokuri-primary-dark, #0099cc);
    }
    .ref-pill__external {
      font-size: 14px;
      width: 14px;
      height: 14px;
      color: rgba(255, 255, 255, 0.7);
    }
  `],
})
export class ReferenceCardComponent {
  readonly searchLinks = input.required<SearchLink[]>();

  protected onLinkClick(event: Event, url: string): void {
    event.preventDefault();
    const confirmed = window.confirm($localize`:@@details.referenceCard.confirmNavigation:外部サイトに移動します。よろしいですか？`);
    if (confirmed) {
      window.open(url, '_blank', 'noopener');
    }
  }
}
